import SvgComponent from "../../SVGComponent";

// Suggestions of props for component while using the components -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef {("button" | "submit")} BtnType
 * @typedef {("white" | "black")} HoverOption
 * @param {Object} props
 * @param {String} props.btnText - Default string to show
 * @param {BtnType} props.btnType - One of "button" or "submit"
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {String} props.enabledTextColor - Color of text when button is enabled (var only)
 * @param {String} props.disabledTextColor - Color of text when button is disabled (var only)
 * @param {String} props.enabledBgColor - Color of bg when button is enabled (var only)
 * @param {String} props.disabledBgColor - Color of bg when button is disabled (var only)
 * @param {boolean} props.isLoading - Is something relevant loading right now (loading state)
 * @param {String} props.icon - Takes svg as an props
 * @param {HoverOption} props.hoverOption - Hover Option Black or White
 * @param {Object} props.buttonRef - Button ref (optional) eg:- state of button ref
 * @param {String} props.imgColor - Takes svg color as an props
 * @param {boolean} props.fullWidthRequired - Full width required (optional {if false then width will be auto}) eg:- true or false
 * @param {boolean} props.inActiveVariantNeeded - If you want to use inActive variant of button eg:- true or false

 * @returns {JSX.Element}
 */
const TopNavSmallButton = ({
  btnText,
  btnType,
  handleFunction,
  isDisabled,
  enabledTextColor,
  enabledBgColor,
  disabledBgColor,
  isLoading,
  icon,
  hoverOption,
  buttonRef,
  fullWidthRequired,
  disabledTextColor,
  imgColor,
  inActiveVariantNeeded,
  isBackgroundRequired = false,
}) => {
  return (
    <button
      ref={buttonRef ? buttonRef : null}
      type={btnType !== null ? btnType : "button"}
      onClick={(e) => {
        if (!isLoading) handleFunction(e);
      }}
      className={`flex justify-center items-center p-padding-xs ${fullWidthRequired ? "w-full" : "w-topnav-small-btn-width"} h-full cursor-${
        isDisabled
          ? `not-allowed ${inActiveVariantNeeded ? "" : "opacity-light-opacity"}`
          : `pointer `
      }`}
      style={{
        backgroundColor:
          isDisabled && disabledBgColor
            ? disabledBgColor?.toString()
            : enabledBgColor?.toString(),
      }}
    >
      <div
        className={`flex  z-z-index-base relative w-full h-full px-padding-button-s py-padding-sm flex-col items-center rounded-border-radius-sm justify-center ${
          isDisabled
            ? ""
            : hoverOption === "white"
              ? "global-hover-white"
              : "global-hover-black"
        }`}
      >
        <div
          className={`${
            isBackgroundRequired
              ? "flex items-center justify-center h-icon-lg w-icon-lg bg-text-primary rounded-border-radius-l p-padding-xs"
              : ""
          } mb-margin-xs`}
        >
          <SvgComponent
            color={imgColor}
            height="var(--icon-lg)"
            width="var(--icon-lg)"
            url={icon}
            alt="Icon"
          />
        </div>
        <div
          className="flex justify-center items-center text-font-xxs font-normal w-full overflow-hidden"
          style={{
            color: disabledTextColor ? disabledTextColor : enabledTextColor,
          }}
        >
          <span className="block w-full text-center truncate whitespace-nowrap">
            {btnText}
          </span>
        </div>
      </div>
    </button>
  );
};

export default TopNavSmallButton;
